import { Component, ChangeDetectorRef, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppRootService, AfidiumApps, IActionLink } from '../../services/app-root/app-root-service';
import { ITab } from 'app/shared/model/ITab';
import { AppHeaderService } from './app-header.service';
import { ConfigurationResourceService } from "libraries/service/resources/configuration/configurationResource.service";
import { CONFIG_HOME, IHomeConfig } from "app_home/home-domain.service";
import { PermissionResourceService } from "libraries/service/resources/permission/permissionResource.service";
import { forkJoin } from "rxjs";

@Component({
    selector: 'app-header',
    templateUrl: 'app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
})
export class AppHeaderComponent implements OnInit{
    public afidiumApps: typeof AfidiumApps = AfidiumApps;
    public lsPrefix: string = sessionStorage.getItem("$instance_url");
    public childrenTabs: ITab[] = [];
    public homeName: string;
    public canShowMenu: boolean;
    public isGlobalNavigationHidden: boolean;
    public canShowDevFunctionality: boolean;

    constructor(
        public appRootService: AppRootService,
        public router: Router,
        public appHeaderService: AppHeaderService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly configurationResourceService: ConfigurationResourceService,
        private readonly permissionResourceService: PermissionResourceService,
    ) { }

    public ngOnInit(): void {
        setTimeout(
            (): void => {
                forkJoin([
                    this.configurationResourceService.get(['wui', 'config', 'home', 'home.json'], CONFIG_HOME),
                    this.permissionResourceService.hasPermission('shared.mainMenu.use'),
                ])
                    .subscribe(([config, canShowMenu]: [IHomeConfig, boolean]): void=>{
                        this.homeName = config.globalName;
                        this.canShowMenu = canShowMenu;
                        this.canShowDevFunctionality = true;
                        this.changeDetectorRef.detectChanges();
                    });
            },
            100
        );
    }


    public navigateTab(childrenTabs: ITab[]): void {
        childrenTabs[0] = {
            ...childrenTabs[0],
            active: true
        };

        this.childrenTabs = childrenTabs;
        this.changeDetectorRef.detectChanges();
    }

    public navigateTo(path: string): void {
        if (path.startsWith('http')) {
            window.location.href = path;
        } else {
            this.router.navigateByUrl(path);
        }
    }

    public onAction(actionLink: IActionLink): void {
        this.appHeaderService.setAction({
            action: actionLink.name,
            application: actionLink.application
        });
    }
}
